import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreAppsFieldsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-apps-fields',
	path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
	exact: true,
};
